import React from 'react';
import ReactDOM from 'react-dom/client';

import '@/index.css';

import { App } from '@/App';
import { preventPinchZoom, registerServiceWorker } from '@/lib/browserSetup';
import { initSentry } from '@/lib/sentry';
import { initWebVitals } from '@/lib/webVitals';

// Initialize error tracking (production only)
initSentry();

// Initialize Web Vitals monitoring
initWebVitals();

registerServiceWorker();
preventPinchZoom();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Could not find root element to mount to');
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
